/* Keep Story's desktop carousel / mobile scroll behavior without CSS text. */
(() => {
  const vendor = window.themeVendor;
  if (!vendor) return;

  const prototypes = new Set(
    [vendor.Flickity, vendor.FlickityFade, vendor.FlickitySync]
      .filter(Boolean)
      .map((Carousel) => Carousel.prototype)
  );

  prototypes.forEach((prototype) => {
    const watchCSS = prototype.watchCSS;
    if (typeof watchCSS !== 'function') return;

    prototype.watchCSS = function () {
      if (this.element.matches('.flickity-disabled-mobile[data-slideshow]')) {
        if (!this.options.watchCSS) return;
        // Match the existing theme.css breakpoint exactly. Flickity calls this
        // during initialization and resize, including in the theme editor.
        if (window.matchMedia('(max-width: 767px)').matches) {
          this.deactivate();
        } else {
          this.activate();
        }
        return;
      }
      return watchCSS.apply(this, arguments);
    };
  });
})();
